import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    Signal,
    computed,
    effect,
    inject,
    input,
} from "@angular/core";

import { HeadService } from "@hermes/utils-generic-services-head";

import {
    DEFAULT_MEDIA_QUERIES_OPTIONS,
    type MediaPicture,
    MediaQueryOption,
} from "../../model/media.types";

import { PosterUrlPipe } from "../../pipes/poster-url/poster-url.pipe";

import { generateLinkDefinitions } from "./media-picture.helpers";

@Component({
    selector: "h-media-picture",
    imports: [PosterUrlPipe],
    templateUrl: "./media-picture.component.html",
    styleUrls: ["./media-picture.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaPictureComponent {
    private headService = inject(HeadService);

    public mediaQueriesOptions = input<MediaQueryOption[]>();

    public title = input<string>();

    public minHeight = input<string>();

    public defaultMediaQueriesOptions = DEFAULT_MEDIA_QUERIES_OPTIONS;

    public mediaPicture = input<MediaPicture>();

    public readonly preload = input.required<boolean>();

    public imageAlt: Signal<string | InputSignal<string | undefined>> =
        computed(() => {
            const mediaPicture = this.mediaPicture();
            return mediaPicture
                ? (mediaPicture.imageAlt ?? this.title() ?? "")
                : "";
        });

    public mediaUrl: Signal<string> = computed(() => {
        const mediaPicture = this.mediaPicture();
        return mediaPicture
            ? mediaPicture.desktopImage || mediaPicture.mobileImage || ""
            : "";
    });

    constructor() {
        effect(() => {
            this.setPreloadLink();
        });
    }

    public trackBySize(_index: number, mediaQueryOptions: MediaQueryOption) {
        return mediaQueryOptions.size;
    }

    private setPreloadLink(): void {
        const linksToAddInTheHead = generateLinkDefinitions(
            this.preload(),
            this.mediaPicture(),
            this.mediaQueriesOptions() ?? DEFAULT_MEDIA_QUERIES_OPTIONS,
        );
        linksToAddInTheHead.forEach((linkToAdd) =>
            this.headService.addTag(linkToAdd),
        );
    }
}
